/*
  Export the configuration.
*/
let config =  {
  APP_NAME: process.env.VUE_APP_NAME,
  API_URL: process.env.VUE_APP_API_URL,
  SERVERLESS_IMAGE_HANDLER: "https://d21qlfkuyb2o0k.cloudfront.net",
  BUCKET: process.env.VUE_APP_BUCKET,
  SSO_URL: process.env.VUE_APP_SSO_URL,
  HRSYNC_URL: process.env.VUE_APP_HRSYNC_URL,
  PARTNER_URL: process.env.VUE_APP_PARTNER_URL ?? '',
  DIRECT_URL: process.env.VUE_APP_DIRECT_URL ?? '',
  FRONTEND_URL: process.env.VUE_APP_FRONTEND_URL ?? '',
  DEMO_PAGE_URL: process.env.VUE_APP_DEMO_PAGE_URL ?? ''
};

export const IMPROVE_CONFIG = config;